const CLIPBOARD_IMAGE_EXTENSIONS = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
  'image/gif': 'gif',
  'image/avif': 'avif',
  'image/heic': 'heic',
  'image/heif': 'heif',
  'image/heic-sequence': 'heic',
  'image/heif-sequence': 'heif',
};

const normalizeMimeType = (value = '') =>
  String(value || '').trim().toLowerCase();

const hasUsableName = (file) =>
  typeof file?.name === 'string' && file.name.trim().length > 0;

const toNamedClipboardFile = (blob, mimeType) => {
  if (!blob) return null;
  if (hasUsableName(blob)) return blob;

  const ext = CLIPBOARD_IMAGE_EXTENSIONS[mimeType];
  const generatedName = `pasted-image.${ext || 'png'}`;
  const options = {
    type: mimeType || blob.type || 'image/png',
    lastModified: Date.now(),
  };

  if (typeof File === 'function') {
    return new File([blob], generatedName, options);
  }

  blob.name = generatedName;
  blob.lastModified = options.lastModified;
  return blob;
};

const isSupportedClipboardImageType = (type) =>
  Boolean(CLIPBOARD_IMAGE_EXTENSIONS[normalizeMimeType(type)]);

const fileFromClipboardItem = (item) => {
  if (!item || item.kind !== 'file') return null;
  const type = normalizeMimeType(item.type);
  if (!isSupportedClipboardImageType(type)) return null;
  const blob = item.getAsFile?.();
  return toNamedClipboardFile(blob, type);
};

const fileFromClipboardFile = (file) => {
  const type = normalizeMimeType(file?.type);
  if (!isSupportedClipboardImageType(type)) return null;
  return toNamedClipboardFile(file, type);
};

export function extractClipboardImageFile(clipboardData) {
  if (!clipboardData) {
    return { file: null, supportedImageCount: 0 };
  }

  const itemCandidates = Array.from(clipboardData.items || [])
    .map(fileFromClipboardItem)
    .filter(Boolean);

  if (itemCandidates.length) {
    return {
      file: itemCandidates[0],
      supportedImageCount: itemCandidates.length,
    };
  }

  const fileCandidates = Array.from(clipboardData.files || [])
    .map(fileFromClipboardFile)
    .filter(Boolean);

  return {
    file: fileCandidates[0] || null,
    supportedImageCount: fileCandidates.length,
  };
}

export default extractClipboardImageFile;
